export const events = {
    SET_ALL_SLUGS: "screenEvents.SET_ALL_SLUGS",
    // SET_ACTIVE_SCREEN_JSON: "screenEvents.SET_ACTIVE_SCREEN_JSON",
    SET_ALL_SCREENS_JSON: "screenEvents.SET_ALL_SCREENS_JSON",
    FORCE_UPDATE: "screenEvents.FORCE_UPDATE",
}

export default {
    setAllSlugsJson: json => {
        return {
            type: events.SET_ALL_SLUGS,
            state: json
        }
    },
    // setActiveScreenJson: json => {
    //     return {
    //         type: events.SET_ACTIVE_SCREEN_JSON,
    //         state: json
    //     }
    // },
    setAllScreensJson: json => {
        return {
            type: events.SET_ALL_SCREENS_JSON,
            state: json
        }
    },
    forceUpdate: () => {
        return {
            type: events.FORCE_UPDATE
        }
    }
}